import { Component, ViewChild, OnInit, ElementRef, Injector } from '@angular/core';
import { BaseComponent } from 'src/app/shared/baseComponent';
import { Gps } from './../../shared/gps';

@Component({
  selector: 'app-gpssimpleread',
  templateUrl: './gpssimpleread.component.html',
  styleUrls: ['./gpssimpleread.component.css']
})
export class GpssimplereadComponent extends BaseComponent implements OnInit {
  @ViewChild('demo',) demo: ElementRef;
  gps = new Gps();
  constructor(injector: Injector) { super(injector) }

  ngOnInit(): void {
  }

  async getLocation() {
    let { ok, data }: any = await this.gps.getLocation();
    if (!ok) return this.error("Cannot get GPS location: ", data);  

    this.showPosition(data);  

  }

  showPosition(coords: any) { //await from getlocation

    this.demo.nativeElement.innerHTML =
      "navigator.geolocation is supported by this browser." +
      "<br>Latitude: " + coords.lat +
      "<br>Longitude: " + coords.lng +
      "<br>Accuracy: " + coords.accuracy + " meter with a 95% confidence level";
  }
}
